import React from 'react';
import _get from 'lodash/get';
import { Box, Typography, makeStyles } from '@material-ui/core';
import VideoEmbedly from 'components/VideoEmbedly';

const useStyles = makeStyles(theme => ({
  videoEmbedly: {
    '& iframe': {
      aspectRatio: '16/9',
      maxHeight: 170,
      padding: 0,
    },
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: props => props.small && '1rem',
  },
  buttonWrapper: {
    marginTop: theme.spacing(2),

    '& button': {
      width: '100%',
    },
  },
}));

export const RecommendedVideoPreview = ({
  item,
  small,
  trackingProps,
  isDashboard,
}) => {
  const classes = useStyles({ small });

  return (
    <>
      <Box className={classes.container}>
        <VideoEmbedly
          url={_get(item, 'fields.url')}
          imageUrl={_get(item, 'fields.imageUrl')}
          id={_get(item, 'sys.id')}
          title={_get(item, 'fields.title')}
          trackingProps={trackingProps}
          className={classes.videoEmbedly}
          eventPrefix={isDashboard ? 'Course Dashboard - Resource' : undefined}
        />
      </Box>
      <Typography
        className={classes.title}
        color="textPrimary"
        variant="subtitle2"
      >
        {item.fields.title}
      </Typography>
    </>
  );
};
